import anodum from 'anodum';
import constants from '../constants';
import isHomePage from '../../site/verifiers/is-home-page';
import getLinkConfig from '../../link-editing/accessors/get-link-config';
import linkTypes from '../../link-editing/constants/link-types';

function findPagesInNavigation(pages, navigationHTML) {
  const navigationNode = anodum.parseElementFromString(navigationHTML);
  const navigationLinks = Array.from(
    navigationNode.querySelectorAll(constants.navigation.LINK_SELECTOR)
  );

  return pages.filter((page) =>
    navigationLinks.some((link) => {
      const config = getLinkConfig(link);
      const isHome = isHomePage(page.path);
      const { linkType, reference } = config;

      if (!isHome) {
        return linkType === linkTypes.PAGE && reference === page.id;
      }

      return linkType === linkTypes.PATH && reference === page.path;
    })
  );
}

export default findPagesInNavigation;
